import * as React from "react";
import { Grid } from "components/controls/widget";
import DivBox from "common/components/controls/DivBox";
import DetailGrid, { DetailGridItem } from "common/components/controls/DetailGrid";
import { withActionsExecutor, ActionsExecutorPropsType, Action, ActionError } from "components/actions";
import VekKtg from "common/utils/VekKtg";
import Loading from "common/components/controls/Loading";
import Error from "common/components/controls/Error";
import * as API from "common/api/Evidence/Clenove/DetailClena";
import { formatDate } from "common/utils/FmtDate";
import PageContent from "common/web/PageContent";

interface State {
    loading: boolean;
    hasError: boolean;
    error?: string;
    soutezniUdaje?: API.SoutezniUdaje;
}

interface ZakladniUdajeProps {
    clenId: number;
    idtClena: number;
    senior: boolean;
}

//type DetailClenaProps = RouteComponentProps<RouteProps>;

type PropsType = ZakladniUdajeProps & State & ActionsExecutorPropsType;


const initialState: State = {
    loading: true,
    hasError: false,
}

class ZakladniUdaje extends React.PureComponent<PropsType> {


    loadSoutezniUdaje = () => {
        const { executeAction, updateState, idtClena, clenId } = this.props;
        const action = API.GetSoutezniUdaje(clenId)
            .onSuccess(d => {
                updateState({ loading: false, soutezniUdaje: d });
            })
            .onError(e => {
                const errMessage = e.errorData && e.errorData.notFound ? `Soutěžní údaje člena(ky) s IDT ${idtClena} nebyly nalezeny` : e.message;
                updateState({ loading: false, hasError: true, error: errMessage });
            });

        executeAction(action, { loading: true, hasError: false });
    }

    componentWillMount() {
        this.loadSoutezniUdaje();
    }

    render() {

        const { loading, hasError, error, soutezniUdaje, senior } = this.props;

        const getSoutLicence = () => {
            return <div>
                {soutezniUdaje.Souticence ? soutezniUdaje.ProfiSoutLicence ? 'PROFI' : 'ANO' : 'NE'}
                {soutezniUdaje.PozastavenaSouticence && <em> (pozastavena)</em>}
            </div>;
        }
        const getZakazStartu = () => {
            return soutezniUdaje.ZakazStartu === true ? 'ANO' : 'NE';
        }

        const getItems = () => {
            const items: DetailGridItem[] = [
                { label: 'Vystupuje za', content: soutezniUdaje.VystupujeZa },
                { label: 'Soutěžní licence', content: getSoutLicence() },
                { label: 'Zdravotní způsobilost', content: <ZdravZpus seznam={soutezniUdaje.PlatneZdravProhlidky} /> },
                { label: 'Zákaz startu', content: getZakazStartu() },
                { divider: true },

                { label: 'Osobní zařazení', group: true, content: <OsobniZarazeni sd={soutezniUdaje} senior={senior} /> },

                { divider: true },

                { label: 'Údaje páru - standard', group: true, content: <DataParu par={soutezniUdaje.ParStt} /> },
                { divider: true },
                { label: 'Údaje páru - latina', group: true, content: <DataParu par={soutezniUdaje.ParLat} /> },


            ];

            return items;
        }

        return <PageContent titles={['Soutěžní údaje', 'Základní údaje']}>
            {loading
                ? <Loading loading={loading} color="primary" />
                : hasError
                    ? <Error>{error}</Error>
                    : <DetailGrid items={getItems()} />}
        </PageContent>
    }
}

export default withActionsExecutor<ZakladniUdajeProps, State>(initialState, ZakladniUdaje);



interface ZdravZpusProps {
    seznam: API.ZdravZpus[];
}

class ZdravZpus extends React.Component<ZdravZpusProps> {
    render() {
        const { seznam } = this.props;

        const getPlatnostDo = (z: API.ZdravZpus) => {
            return z.DoData ? ', platné do ' + formatDate(z.DoData) : '';
        }

        return <div>
            {seznam.length === 0 ? 'není doložená/platná' : seznam.map((z, k) => <div key={k}>{z.Nazev + ' ze dne ' + formatDate(z.Datum) + getPlatnostDo(z)}</div>)}
        </div>
    }
}



interface VykDataProps {
    vd?: API.VykData;
}

class VykData extends React.Component<VykDataProps> {
    render() {
        const { vd } = this.props;

        return (vd && vd.Trida) ? <div>
            {'třída: ' + vd.Trida + ', body: ' + vd.Body + ', finále tuz./zahr.: ' + vd.FinTuz + '/' + vd.FinZahr}
        </div> : <em>{'neurčeno'}</em>;
    }
}



interface NejTridyProps {
    sd: API.SoutezniUdaje;
    senior: boolean;
}

class NejTridy extends React.Component<NejTridyProps> {
    render() {
        const { sd, senior } = this.props;

        const getTrida = (t: string) => {
            return t ? <span>{t}</span> : <em>{'žádná'}</em>;
        }

        const getContentStt = () => {
            return senior
                ? <Grid item>{'standard: '}{getTrida(sd.NejTridaStt)}{', standard (SE): '}{getTrida(sd.NejTridaSttSe)}</Grid >
                : <Grid item>{'standard: '}{getTrida(sd.NejTridaStt)}</Grid >;
        }

        const getContentLat = () => {
            return senior
                ? <Grid item>{'latina: '}{getTrida(sd.NejTridaLat)}{', latina (SE): '}{getTrida(sd.NejTridaLatSe)}</Grid>
                : <Grid item>{'latina: '}{getTrida(sd.NejTridaLat)}</Grid>;
        }

        return <Grid container wrap="nowrap" justify="space-between" direction="column" spacing={8}>
            {getContentStt()}
            {getContentLat()}
        </Grid>
    }
}



interface OsobniZarazeniProps {
    sd: API.SoutezniUdaje;
    senior: boolean;
}

class OsobniZarazeni extends React.Component<OsobniZarazeniProps> {
    render() {
        const { sd, senior } = this.props;
        const getItems = () => {
            const items: DetailGridItem[] = [
                { label: 'Standard', content: <VykData vd={sd.VykDataStt} /> },
                { label: 'Latina', content: <VykData vd={sd.VykDataLat} /> },

                { label: 'Standard (SE)', content: <VykData vd={sd.VykDataSttSe} />, show: senior },
                { label: 'Latina  (SE)', content: <VykData vd={sd.VykDataLatSe} />, show: senior },


                { label: 'Nejvyšší dosažené třídy', content: <NejTridy sd={sd} senior={senior} /> },


            ];

            return items;
        }
        return <DetailGrid items={getItems()} />
    }
}



interface DataParuProps {
    par?: API.Par;
}

class DataParu extends React.Component<DataParuProps> {
    render() {
        const { par } = this.props;

        const getItems = () => {
            const items: DetailGridItem[] = [
                { label: 'Partner(ka)', content: par.PartnerPrijmeni + ' ' + par.PartnerJmeno + ' (' + par.PartnerIdt + ')' },
                { label: 'Věková kategorie', content: VekKtg.getNazevVekoveKategorie(par.VekKtg) },
                { label: 'Vystupují za', content: <VystupujiZa vz={par.VystupujiZa} /> },
                { label: 'Zařazení', content: <VykData vd={par.VykData} /> },
                { label: 'Zařazení (SE)', content: <VykData vd={par.VykDataSe} />, show: par.SeniorskyPar },
            ];

            return items;
        }

        return par ? <DetailGrid items={getItems()} /> : <em>{'bez partnera(ky)'}</em>;
    }
}

interface VystupujiZaProps {
    vz?: API.VystupujiZa;
}

class VystupujiZa extends React.Component<VystupujiZaProps> {

    render() {
        const { vz } = this.props;
        const ruznyKlub = vz.PartnerKlubId !== vz.PartnerkaKlubId;
        return ruznyKlub
            ? <Grid container wrap="nowrap" justify="space-between" direction="column" spacing={8}>
                <Grid item>{vz.PartnerVystZa + ' (partner)'}</Grid>
                <Grid item>{vz.PartnerkaVystZa + ' (partnerka)'}</Grid>
                <Grid item><DivBox noPadding weight="lighter"><em>{'- pro účast na soutěži bude potřeba u jednoho z páru vyřídit dlouhodobé nebo krátkodobé hostování do klubu partnera(ky).'}</em></DivBox></Grid>
            </Grid>
            : <div>{vz.PartnerVystZa}</div>
    }
}
